import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { CONSTANT_VALUES } from '../../constants/constant-values';
import { environment } from '../../../environments/environment';
import { HttpInterceptor } from '../../shared/index';

@Injectable()
export class AuthenticationService {

    constructor(private http: HttpInterceptor) {
    }

    /**
         * Call vendor sign in api
         *
         * @param vendor's email id and password
         *
         * @response got vendor signed in
         */
    signIn(vendorData) {
        let url = CONSTANT_VALUES.URL_VENDOR_SIGN_IN;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorData).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    /**
         * Call vendor sign up api
         *
         * @param vendor's object
         *
         * @response got vendor signed up
         */
    signUp(vendorData) {
        let url = CONSTANT_VALUES.URL_VENDOR_CREATE;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorData).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    /**
         * Call vendor forgot api
         *
         * @param vendor's object
         *
         * @response got password to email id
         */
    forgotPassword(vendorData) {
        try {
            let url = CONSTANT_VALUES.URL_FORGOT_PASSWORD;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorData).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Get vendor credentials from local storage
     */
    getRememberedVendor() {
        let vendorObj;
        if (localStorage.getItem('vendorRemember')) {
            vendorObj = JSON.parse(atob(localStorage.getItem('vendorRemember')));
            return vendorObj;
        } else {
            return null;
        }
    }

    changePassword(changePasswordObj) {
        let url = CONSTANT_VALUES.CHANGE_PASSWORD;
        return new Promise((resolve, reject) => {
            this.http.post(url, changePasswordObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    editVendorInfo(vendorObj) {
        let url = CONSTANT_VALUES.VENDOR_EDIT;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    getVendorInfo(vendorObj) {
        let url = CONSTANT_VALUES.VENDOR_DETAILS;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/shared/authentication.service.ts